export default class EmployeeService {
  constructor (http, store, router) {
    this.$http = http
    this.$store = store
    this.$router = router
  }

  getEmployees () {
    return new Promise((resolve, reject) => {
      this.$http.get('employee')
        .then(res => res.data)
        .then(data => {
          resolve(data.data)
        })
        .catch(reject)
    })
  }

  findEmployee (id) {
    return new Promise((resolve, reject) => {
      this.$http.get(`employee/${id}`)
        .then(res => res.data)
        .then(data => {
          resolve(data.data)
        })
        .catch(reject)
    })
  }

  getArchiveEmployees () {
    return new Promise((resolve, reject) => {
      this.$http.get('employee/archive/all')
        .then(res => res.data)
        .then(data => {
          resolve(data.data)
        })
        .catch(reject)
    })
  }

  restoreEmployee (id) {
    return new Promise((resolve, reject) => {
      this.$http.post(`employee/archive/${id}/restore`)
        .then(res => res.data)
        .then(data => {
          resolve(data.data)
        })
        .catch(reject)
    })
  }

  getEmployeeTypes () {
    return new Promise((resolve, reject) => {
      this.$http.get('employee/type')
        .then(res => res.data)
        .then(data => {
          resolve(data.data)
        })
        .catch(reject)
    })
  }

  createEmployeeType (data) {
    return new Promise((resolve, reject) => {
      this.$http.post('employee/type/create', data)
        .then(res => res.data)
        .then(data => {
          resolve(data.data)
        })
        .catch(reject)
    })
  }

  updateEmployeeType (id, data) {
    return new Promise((resolve, reject) => {
      this.$http.post(`employee/type/${id}/update`, data)
        .then(res => res.data)
        .then(data => {
          resolve(data.data)
        })
        .catch(reject)
    })
  }

  createEmployee (data) {
    return new Promise((resolve, reject) => {
      this.$http.post('employee/create', data)
        .then(res => res.data)
        .then(data => {
          if (data.status === 'error') reject(new Error(data.message))
          resolve(data)
        })
        .catch(reject)
    })
  }

  getEmployeePayments (id) {
    return new Promise((resolve, reject) => {
      this.$http.get(`employee/${id}/payments`)
        .then(res => res.data)
        .then(data => {
          if (data.status === 'error') reject(new Error(data.message))
          resolve(data)
        })
        .catch(reject)
    })
  }

  cashInDebt (id, data) {
    return new Promise((resolve, reject) => {
      this.$http.post(`employee/${id}/debts/cash-in`, data)
        .then(res => res.data)
        .then(data => {
          resolve(data)
        })
        .catch(reject)
    })
  }
}
